import { z } from 'zod'

export const schema = z.array(
  z.object({
    provinceName: z.string(),
    villageName: z.string(),
    image: z.string(),
    url: z.string(),
    maxCapacity: z.number(),
    rating: z.object({
      rating: z.number(),
      votes: z.number(),
    }),
    priceAverage: z.number(),
    priceSummary: z
      .object({
        price: z.number().nullable(),
        type: z.union([z.literal('from'), z.literal('exact')]).nullable(),
      })
      .nullable(),
  }),
)

export type schemaType = z.infer<typeof schema>
